// Nav Color Change
/* (function () {
  const NAV = document.querySelector('.nav');
  if (!NAV) return;

  const SELECTORS = [
    '[data-wf--intro-secondary--variant]',
    '[data-wf--tabs--variant]',
    '[data-wf--anchor-list-section--variant]',
    'section.is-black',
    'section.is-grey',
    'section'
  ];

  const SECTIONS = Array.from(
    new Set(SELECTORS.flatMap(sel => Array.from(document.querySelectorAll(sel))))
  );

  if (!SECTIONS.length) return;

  function themeOf(el) {
    const cls = el.className || '';

    if (/\bis-black\b/.test(cls)) return 'black';
    if (/\bis-grey\b/.test(cls)) return 'grey';

    const attrs = [
      el.getAttribute('data-wf--intro-secondary--variant'),
      el.getAttribute('data-wf--tabs--variant'),
      el.getAttribute('data-wf--anchor-list-section--variant'),
      el.getAttribute('data-wf--section-construction--variant')
    ].filter(Boolean).map(v => v.toLowerCase());

    if (attrs.some(v => v.includes('dark') || v.includes('black')))
      return 'black';

    if (attrs.some(v => v.includes('grey') || v.includes('gray')))
      return 'grey';

    return 'base';
  }

  function apply(theme) {
    NAV.classList.toggle('is-base', theme === 'base');
    NAV.classList.toggle('is-grey', theme === 'grey');
    NAV.classList.toggle('is-black', theme === 'black');
  }

  function update() {
    const navBottom = NAV.getBoundingClientRect().bottom;
    let chosen = null;

    for (const el of SECTIONS) {
      const r = el.getBoundingClientRect();
      if (r.top <= navBottom && r.bottom > navBottom) {
        chosen = el;
        break;
      }
    }

    apply(chosen ? themeOf(chosen) : 'base');
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });

  if ('ResizeObserver' in window) {
    const ro = new ResizeObserver(update);
    ro.observe(NAV);
    SECTIONS.forEach(el => ro.observe(el));
  }

  requestAnimationFrame(update);
})(); */

// Navbar Dropdowns sync between m and d and Footer dropdowns functions

document.addEventListener('DOMContentLoaded', function () {
  function isMobile() {
    return window.matchMedia('(max-width: 766px)').matches;
  }

  var dropdowns = document.querySelectorAll('.navbar__dropdown');
  var overlay = document.querySelector('.navbar__overlay');
  var overlayClose = document.querySelector('.navbar__overlay-close');
  var nav = document.querySelector('.nav');

  var OPEN_DELAY = 120;
  var CLOSE_DELAY = 220;
  var PANEL_SHOW_DELAY = 90;

  var openTimer = null;
  var closeTimer = null;
  var panelTimer = null;
  var currentDropdown = null;

  var desktopBound = false;

  function updateOverlaySize(dropdown) {
    if (!overlay || !dropdown) return;
    var panel = dropdown.querySelector('.navbar__dropdown--content-wrap');
    if (!panel) return;
    overlay.style.height = panel.offsetHeight + 'px';
  }

  function openDropdown(dropdown) {
    clearTimeout(panelTimer);

    if (currentDropdown === dropdown) {
      updateOverlaySize(dropdown);
      return;
    }

    dropdowns.forEach(function (d) {
      d.classList.remove('is-open');
    });

    currentDropdown = dropdown;

    if (overlay) {
      overlay.classList.add('is-active');
      updateOverlaySize(dropdown);
    }

    panelTimer = setTimeout(function () {
      dropdowns.forEach(function (d) {
        if (d !== dropdown) d.classList.remove('is-open');
      });
      dropdown.classList.add('is-open');
    }, PANEL_SHOW_DELAY);
  }

  function closeDropdown() {
    clearTimeout(panelTimer);
    dropdowns.forEach(function (d) {
      d.classList.remove('is-open');
    });
    currentDropdown = null;
    if (overlay) {
      overlay.classList.remove('is-active');
      overlay.style.height = '0px';
    }
  }

  function scheduleOpen(dropdown) {
    clearTimeout(openTimer);
    openTimer = setTimeout(function () {
      openDropdown(dropdown);
    }, OPEN_DELAY);
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      closeDropdown();
    }, CLOSE_DELAY);
  }

  function onDropdownEnter(e) {
    clearTimeout(closeTimer);
    scheduleOpen(e.currentTarget);
  }

  function onDropdownLeave() {
    scheduleClose();
  }

  function onNavLeave() {
    scheduleClose();
  }

  function onOverlayClick() {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    closeDropdown();
  }

  function bindDesktopHover() {
    if (desktopBound) return;
    desktopBound = true;

    dropdowns.forEach(function (dropdown) {
      dropdown.addEventListener('mouseenter', onDropdownEnter);
      dropdown.addEventListener('mouseleave', onDropdownLeave);
    });

    if (nav) nav.addEventListener('mouseleave', onNavLeave);

    [overlay, overlayClose].forEach(function (el) {
      if (!el) return;
      el.addEventListener('click', onOverlayClick);
    });
  }

  function unbindDesktopHover() {
    if (!desktopBound) return;
    desktopBound = false;

    dropdowns.forEach(function (dropdown) {
      dropdown.removeEventListener('mouseenter', onDropdownEnter);
      dropdown.removeEventListener('mouseleave', onDropdownLeave);
    });

    if (nav) nav.removeEventListener('mouseleave', onNavLeave);

    [overlay, overlayClose].forEach(function (el) {
      if (!el) return;
      el.removeEventListener('click', onOverlayClick);
    });

    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    clearTimeout(panelTimer);
    closeDropdown();
  }

  function bindMobileAccordions() {
    var footerTrigger = '.footer__content-col--trigger';
    var footerPanel = '.footer__links--wrap';

    var navTrigger = '.navbar__dropdown';
    var navPanel = '.navbar__dropdown--content-wrap';

    var menuBtn = '.navbar__menu-btn';

    function closeMobileNavDropdowns() {
      $(navTrigger).removeClass('is-active');
      $(navPanel).stop(true, true).slideUp();

      $(navTrigger).removeClass('is-open');
      if (overlay) {
        overlay.classList.remove('is-active');
        overlay.style.height = '0px';
      }
      currentDropdown = null;
    }

    $(document).off('click.mobileFooter', footerTrigger);
    $(document).off('click.mobileNav', navTrigger);
    $(document).off('click.mobileMenu', menuBtn);

    if (!isMobile()) {
      $(footerTrigger).removeClass('is-active');
      $(footerPanel).stop(true, true).removeAttr('style');

      $(navTrigger).removeClass('is-active');
      $(navPanel).stop(true, true).removeAttr('style');

      $(navTrigger).removeClass('is-open');
      if (overlay) {
        overlay.classList.remove('is-active');
        overlay.style.height = '0px';
      }
      currentDropdown = null;
      return;
    }

    dropdowns.forEach(function (d) {
      d.classList.remove('is-open');
    });
    if (overlay) {
      overlay.classList.remove('is-active');
      overlay.style.height = '0px';
    }
    currentDropdown = null;

    $(document).on('click.mobileFooter', footerTrigger, function () {
      var $t = $(this);
      var $p = $t.next();

      if ($t.hasClass('is-active')) {
        $t.removeClass('is-active');
        $p.stop(true, true).slideUp();
        return;
      }

      $(footerTrigger).removeClass('is-active');
      $(footerPanel).stop(true, true).slideUp();

      $t.addClass('is-active');
      $p.stop(true, true).slideDown();
    });

    $(document).on('click.mobileNav', navTrigger, function (e) {
      if ($(e.target).closest(navPanel).length) return;

      var $t = $(this);
      var $p = $t.find(navPanel).first();

      if ($t.hasClass('is-active')) {
        $t.removeClass('is-active');
        $p.stop(true, true).slideUp();
        return;
      }

      $(navTrigger).removeClass('is-active');
      $(navPanel).stop(true, true).slideUp();

      $t.addClass('is-active');
      $p.stop(true, true).slideDown();
    });

    $(document).on('click.mobileMenu', menuBtn, function () {
      closeMobileNavDropdowns();
    });
  }

  function syncMode() {
    if (isMobile()) {
      unbindDesktopHover();
      bindMobileAccordions();
    } else {
      bindMobileAccordions();
      bindDesktopHover();
      if (currentDropdown) updateOverlaySize(currentDropdown);
    }
  }

  var mql = window.matchMedia('(max-width: 766px)');
  if (mql.addEventListener) mql.addEventListener('change', syncMode);
  else if (mql.addListener) mql.addListener(syncMode);

  syncMode();

  window.addEventListener('resize', function () {
    if (!isMobile() && currentDropdown) updateOverlaySize(currentDropdown);
  });



  // newsletter form
  const trigger = document.querySelector('#newsletter-submit-trigger')
  const button = document.querySelector('#newsletter-submit')
  trigger.addEventListener('click', () => button.click())
  // Pseudoaccordion

  const wraps = document.querySelectorAll('.content__pseudo-accordion--wrap');
  const activeClass = 'content__pseudo-accordion--active';
  const perItemHeightSvH = 50;

  if (!wraps.length) return;

  function setWrapHeights() {
    wraps.forEach(wrap => {
      const items = wrap.querySelectorAll('.content__pseudo-accordion');
      if (!items.length) return;
      const heightValue = items.length * perItemHeightSvH;
      wrap.style.height = heightValue + 'svh';
    });
  }

  function updateAccordions() {
    const viewportHeight = window.innerHeight;

    wraps.forEach(wrap => {
      const items = wrap.querySelectorAll('.content__pseudo-accordion');
      if (!items.length) return;

      const rect = wrap.getBoundingClientRect();
      const wrapHeight = rect.height;

      if (rect.bottom <= 0 || rect.top >= viewportHeight) {
        items.forEach(item => item.classList.remove(activeClass));
        return;
      }

      let extra = wrapHeight - viewportHeight;
      if (extra <= 0) extra = 1;

      let inside = -rect.top;
      if (inside < 0) inside = 0;
      if (inside > extra) inside = extra;

      let progress = inside / extra;
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;

      const step = 1 / items.length;
      let activeIndex = Math.floor(progress / step);
      if (activeIndex < 0) activeIndex = 0;
      if (activeIndex >= items.length) activeIndex = items.length - 1;

      items.forEach((item, index) => {
        if (index === activeIndex) item.classList.add(activeClass);
        else item.classList.remove(activeClass);
      });
    });
  }

  setWrapHeights();
  updateAccordions();

  window.addEventListener('scroll', updateAccordions);
  window.addEventListener('resize', () => {
    setWrapHeights();
    updateAccordions();
  });
});